export default __webpack_public_path__ + "./img/notifications.a95d71a6618e94d37b7a597a183e8e6f.png";